import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios'
import {useLang} from "./LangProvider";


function DocumentsList(menuHandler) {

  const [docs, setDocs] = useState(null)
  const {lang, t} = useLang()



  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND_DOCUMENTS,{
        headers:{
          accept:"application/json"
        },
        params:{
            with_text:1
        }
      })
      .then(
        res=>{
          console.log('docs readed', res.data)
          setDocs(res.data)
        }
      )
      .catch(() => {
        setDocs(null)
      })
  },[])

  // return list
  return <> {docs ? docs.map(doc =>
    <Link
      key={doc.id}
      onClick={() => menuHandler()}
      to={'/document/'+doc.id}>
      {t(doc[lang["lang"]]?.name ?? doc.text_block?.name ?? doc.name)}
    </Link>
  ): <Link to="#">err:404</Link>}
  </>

}

export default DocumentsList